import type { DeltaSyncApiVer, DeltaSyncClientVer } from '../types';

export const DELTA_SYNC_CLIENT_VER: DeltaSyncClientVer = 1;
export const DELTA_SYNC_API_VER: DeltaSyncApiVer = 'v2';
